import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { esferasOptions } from 'services/esferas_contracts';

ChartJS.register(ArcElement, Tooltip, Legend);

interface Props {
  data: Record<number, number>;
}

const colors = ['#3B82F6', '#8B5CF6', '#10B981', '#F59E0B', '#EC4899'];

const EsferaOverview = ({ data }: Props) => {
  const formatted = esferasOptions
    .map((item) => ({
      label: item.label,
      value: data?.[item.value] || 0,
    }))
    .filter((item) => item.value > 0);

  const chartData = {
    datasets: [
      {
        data: formatted.map((item) => item.value),
        backgroundColor: colors,
        borderWidth: 0,
      },
    ],
  };

  return (
    <div>
      <h5 className="mb-3 d-flex align-items-center" style={{ gap: 8 }}>
        <i className="material-icons" style={{ color: '#9810FA' }}>
          show_chart
        </i>
        <span>Por Esfera</span>
      </h5>
      <div style={{ width: 100, margin: '0 auto' }}>
        <Doughnut data={chartData} />
      </div>

      <div className="mt-4">
        {formatted.map((item, index) => (
          <div key={item.label} className="d-flex justify-content-between align-items-center mb-2">
            <div className="d-flex align-items-center">
              <div
                style={{
                  width: 10,
                  height: 10,
                  borderRadius: '50%',
                  backgroundColor: colors[index],
                  marginRight: 8,
                }}
              />
              <span>{item.label}</span>
            </div>

            <span>{item.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default EsferaOverview;
